module.exports = __webpack_public_path__ + "static/media/varie2.748c468e.jpg";